export default {
      id: "menu-logo-usage",
      viewBox: "0 0 41.938 18.298",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#menu-logo",
      toString: function () {
        return this.url;
      }
    }